<template>
  <table style="margin-top: -10px;">
      <tbody>
        <tr >
          <td width="100"><v-switch :label="cab?'CAB':'EAN13'" v-model="cab"></v-switch></td>
          <td width="100"></td>
          <td width="200"><v-switch :label="repart?'Répartition':'Stock'" v-model="repart"></v-switch></td>
        </tr>
      </tbody>
  </table>
 
  <table style="margin-top: -30px;">
    <v-card>
      <tbody>
        <tr>
          <th width="100"  > Image</th>
          <th>Nom Appel</th>
          <th>Réf fourn</th>
          <th>Désignation</th>
          <th>Collection</th>
          <th>Répart</th>
          <th>Dépot</th>
          <th>Mag</th>
          <th >Prix</th>
        </tr>
        <tr >
          <td  width="100" class="iconplus" @click="dialog=true">
            <v-icon class="iconplus" icon="mdi-plus"  ></v-icon>
          </td>
          <td>{{ props.references[Object.keys(props.references)[0]].reference_y2 }}</td>
          <td><input type="text" style="text-align:center" :value="props.references[Object.keys(props.references)[0]].ref_fourn" @change.prevent="updateReference('ref_fourn',$event.target.value)"/></td>
          <td><input type="text" style="text-align:center" :value="props.references[Object.keys(props.references)[0]].designation" @change.prevent="updateReference('designation',$event.target.value)"/></td>
          <td> 
            <select name="collections" id="collections" v-model="collectionRef" >
              <option  v-for="key in collections">{{key}}</option>
            </select>
          </td>
          <td  class="iconplus" @click="repartDialog=true">
            <v-icon class="iconplus" icon="mdi-plus"  ></v-icon>
          </td>
          <td>{{ sumAD(etabDEPO.etabliss) }}</td>
          <td>{{ sumAD(etabEdiFrNord.etabliss)+sumAD(etabEdiPDC.etabliss)+sumAD(etabEdiBE.etabliss)+sumAD(etabLc.etabliss)+sumAD(etabEtrier.etabliss)   }}</td>
          <td>€<input type="text"
              :value="Number(props.references[Object.keys(props.references)[0]].vte_euro).toFixed(2)" 
              @input="$event.target.value = $event.target.value
                .replace(',', '.')
                .match(/^\d*\.?\d{0,2}/)?.[0] || '';"
              @change="updatePrix($event.target.value, true)" size="5"  />
          </td>
        </tr>
        <tr>
          <td width="100" class="iconrefresh" @click="refreshPrices(store.state.etablissement,store.state.date)">
            <v-icon color="primary" class="iconrefresh" icon="mdi-refresh"  ></v-icon>
          </td>
          <td colspan="20" style="text-align:left">
            <v-chip size="x-small" @click="dialogDimensions=true">{{ props.references[Object.keys(props.references)[0]].dimension }}</v-chip>
            <v-chip  size="x-small"@click="dialogDimensions=true">{{ Number(props.references[Object.keys(props.references)[0]].poidsnet).toFixed(3) }} Kg</v-chip>
            <v-chip v-if="props.references[Object.keys(props.references)[0]].volume" size="x-small"@click="dialogDimensions=true">{{ Number(props.references[Object.keys(props.references)[0]].volume).toFixed(3) }} L</v-chip>
            <span :style="[props.references[Object.keys(props.references)[0]].type_promo=='PBG'?{color:'blue','margin-left': '10px'}:{color:'red','margin-left': '10px'}]">{{ periodProperties }}</span>
          </td>
          <td colspan="20"></td>
        </tr>
        <tr >
          <td rowspan="30" width="100" valign="top" ><img style="border: 0.1em  solid lightgrey"  @click="imageDialog=true;srcImage=`https://www.edisac.com/images/article_la/${photo_name}`"  :src="`${photo_name?'https://www.edisac.com/images/article_la/'+photo_name:'https://www.edisac.com/images/article_la/nopic2.gif'}`" alt="Italian Trulli" max-width="200px" width="100%" height="100%">
              <v-btn   
                color="primary" 
                v-if="isChanged.promo||isChanged.prixBase"
                @click="validerPromo()" 
                size="large" 
                rounded="0" 
                variant="text"
                density="compact">
                Valider
            </v-btn> 
          </td>
          <td colspan="20">
            <table>
              <tbody class="tableArticle">
                <tr style="border-bottom: 0.1em  solid;border-color:lightgrey ;">
                  <th width="90"> couleur</th>
                  <th width="40">taille</th>
                  <th width="60">Prix</th>
                  <th width="50" v-if="!visiblefunction&&!visible">Promo</th>
                  <th width="40" v-if="visiblefunction||visible">Remise</th>
                  <th width="60" v-if="visiblefunction||visible">Type</th>
                  <th width="50" v-if="visiblefunction||visible">Promo</th>
                  <th width="50" >Collec.</th>
                  <th class="filiale" @click="getReliquat()" title="Afficher les compteurs de la référence">Info</th>
                  <th width="40" class="filiale"  v-for="el in etabDEPO.etabliss " :key="el"><span>{{ el }}</span></th>
                  <th width="40" class="filiale" v-if="!['DEPO','DWEB'].find(el=>el==store.state.etablissement)" ><span>{{ store.state.etablissement }}</span></th>
                  <th width="50" class="filiale" @click="edisacFrance()"><span >France</span></th>
                  <th class="etabclass"  v-if="edisacFranceCol"   v-for="el in etabEdiFrNord.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                  <th class="etabclass"  v-if="edisacFranceCol"   v-for="el in etabEdiPDC.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacBelgique()"><span >Belgique</span> </th>
                  <th class="etabclass"  v-if="edisacBelgiqueCol"   v-for="el in etabEdiBE.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacLongchamp()"><span >Longchamp</span> </th>
                  <th class="etabclass"  v-if="etabLcCol"   v-for="el in etabLc.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacEtrier()"><span >Etrier</span> </th>
                  <th class="etabclass"  v-if="etabEtrierCol"   v-for="el in etabEtrier.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacReflex()"><span >Reflex</span> </th>
                  <th class="etabclass"  v-if="etabReflexCol"   v-for="el in etabReflex.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacAD()"><span >AD</span> </th>
                  <th class="etabclass"  v-if="etabADCol"   v-for="el in etabAD.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> {{ el }}</th>
                </tr>
                  <Color  
                    v-for="article in ordered(references)" 
                    :article 
                    :col 
                    :cab 
                    :repart 
                    v-model="visible" 
                    :visiblefunction 
                    @isChangedCol="(value)=>{isChanged=value}"
                    @photo_name="(name)=>{photo_name=name}"
                  >
                  </Color>
                  
              </tbody>
            </table> 
          </td>
        </tr>
      </tbody>
    </v-card>
    </table>
      <Repartition v-if="repartDialog"
      :article="props.references[Object.keys(props.references)[0]]"
      v-model="repartDialog"
      :articleRepart="{type:'ref'}"
      ></Repartition>
      <v-dialog
        v-model="dialog"
        max-width="400"
      ><v-card
          title="Fiche Article"
        ><v-card-text>
            <v-row dense>
              <v-col cols="12"  md="4" sm="6">
                <v-text-field 
                  label="Acheteur"
                  v-model="acheteur"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4"  sm="6">
                <v-text-field  label="Pôle"    v-model="pole" density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4"  sm="6">
                <v-text-field
                  label="Code dounier"
                  v-model="douanier"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12" md="4"  sm="6">
                <v-text-field
                  label="Composition"
                  v-model="composition"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col cols="12"  md="4" sm="6">
                <v-text-field
                  label="Pays"
                  v-model="pays"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4" sm="6">
                <v-text-field
                  label="Fournisseur"
                  v-model="fournisseur"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4"  sm="6">
              <v-text-field
                  label="Code Thème"
                  v-model="codeTheme"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4"  sm="6">
              <v-text-field
                  label="Code marque" 
                  v-model="codemarque"
                  density="compact" variant="outlined"
              ></v-text-field>
              
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field label="Prix Achat" v-model="PrixAchat" density="compact" variant="outlined"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" sm="6">
                  <v-btn color="red" v-if="articleInSolde().cond"
                    @click="articleInSolde().type.match(/sol/)?dialogSolde=true:deletePromo();dialogFinale=true"
                  >Supprimer promo</v-btn>
              </v-col>
            </v-row>
            <small class="text-caption text-medium-emphasis">*indicates required field</small>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text="Fermer" variant="plain" @click="dialog = false" color="red"></v-btn>
            <v-btn color="primary" text="Valider" variant="plain" @click="dialog = false"></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- </div> -->

    <!-- <div class="text-center pa-4"> -->
      <v-dialog v-model="dialogFinale" width="auto">
        <v-card max-width="400" prepend-icon="$error"
        :text="`La référence ${props.references[Object.keys(props.references)[0]].reference_y2} a été supprimé de la promotion ${props.references[Object.keys(props.references)[0]].type_promo}`"
        title="Supression promo"
        >
        <template v-slot:actions>
          <v-btn class="ms-auto" text="OK" @click="dialogFinale = false"></v-btn>
        </template>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSolde" width="auto">
        <v-card max-width="400" prepend-icon="$error"
        :text="`La référence ${props.references[Object.keys(props.references)[0]].reference_y2} est en solde, selectionnez les démarques à suprrimer SVP!`"
        title="Suppression soldes"
        >
        <v-row>
            <v-checkbox label="VP" v-model="vp" style="margin-left: 20%;" ></v-checkbox>
            <v-checkbox label="D1" v-model="d1"  ></v-checkbox>
            <v-checkbox label="D2" v-model="d2" ></v-checkbox> 
            <v-checkbox label="D3" v-model="d3" ></v-checkbox>
            <v-checkbox label="OT" v-model="ot" ></v-checkbox>
        </v-row>
        <template v-slot:actions>
            <v-btn color="red" text="Annuler" @click="dialogSolde = false;dialogFinale=false"></v-btn>
            <v-btn color="green" text="Valider" @click="deletePromo();dialogSolde = false;dialogFinale=true"></v-btn>
        </template>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDimensions" width="auto">
        <v-card max-width="400" prepend-icon="$error"
        
        title="Dimensions"
        ><form action="" @submit.prevent="validerArticles()">
          <v-card-text>
            <v-row>
              <v-col >
                <v-text-field 
                  clearable 
                  type="text" 
                  v-model="props.references[Object.keys(props.references)[0]].dimension"
                  label="Dimensions" 
                  density="compact"
                  variant="outlined"
                  placeholder="L*H*P"
                  :rules="rules2(props.references[Object.keys(props.references)[0]].dimension,'Dimensions','^\\d+(?:\\.\\d+)?\\*\\d+(?:\\.\\d+)?(?:\\*\\d+(?:\\.\\d+)?)?$')"
                  @change.prevent="updateReference('dimension',$event.target.value)" 
              >
              </v-text-field>
              </v-col>
            </v-row>
            <v-row>
                <v-col >
              <v-text-field 
                  clearable 
                  type="number" 
                  v-model="props.references[Object.keys(props.references)[0]].poidsnet"
                  label="Poids" 
                  density="compact"
                  variant="outlined"
                  placeholder="0.00"
                  prefix="Kg"
                  :rules="rules2(props.references[Object.keys(props.references)[0]].poidsnet,'Poids','^[0-9]*[.,]?[0-9]*$')"
                  @change.prevent="updateReference('poidsnet',$event.target.value)" 
              >
              </v-text-field>
              </v-col>
           
              <v-col >
              <v-text-field 
                  clearable 
                  type="number" 
                  v-model="props.references[Object.keys(props.references)[0]].volume"
                  label="Volume" 
                  density="compact"
                  variant="outlined"
                  prefix="L"
                  placeholder="0.00"
                  :rules="rules2(props.references[Object.keys(props.references)[0]].volume,'Volume','^[0-9]*[.,]?[0-9]*$')"
                  @change.prevent="updateReference('volume',$event.target.value)"
              >
              </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text="Annuler" variant="plain" @click="dialogSolde = false;dialogDimensions=false"></v-btn>
            <v-btn :disabled="!valid" color="green" text="Valider" variant="plain" @click="isChanged.dimensions=true;validerArticles();showSnackbar(`Les dimensions de la référence ${props.references[Object.keys(props.references)[0]].reference_y2} ont été modifiés`, 'success');dialogDimensions = false"></v-btn>
          </v-card-actions>
        </form>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="imageDialog"
        width="600"
      >
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
      <InfosQuantities v-if="qteDialog"
          :productData
          :storeOptions
          v-model="qteDialog"
      >

      </InfosQuantities>
      <v-dialog v-model="allColors.validation" width="auto">
        <v-card max-width="500" prepend-icon="mdi-percent"
        title="Modification prix de base"
        >
        <v-card-text>
          <div v-if="allColors.prix<=0">
              <p>Veuillez saisir un prix supérieur à <b>0 €</b></p>
          </div >
          <div v-else>
            <p>Vous êtes en train d'appliquer le prix de <b>{{allColors.prix}} €</b> à toutes les couleurs de la référence <b>{{allColors.reference}}</b></p>
            <p>Souhaitez-vous confirmer cette modification ?</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="warning" :text="`${allColors.prix>0?'Non':'OK'}`" @click="allColors.validation = false"></v-btn>
          <v-btn v-if="allColors.prix>0" :loading="isChanged.prixBase" color="green" text="Oui" @click="updatePrix(allColors.prix,false)"></v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        timeout="2000"
        location="top"
      >
        {{ snackbarMessage }}
        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar = false">
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
  
</template>
  <script setup>
  import {onMounted,computed, ref, watch, toRefs,onUpdated} from 'vue'
  import Color from './Color.vue';
  import store from './store'
  import Repartition from './components/Repartition.vue'
  import InfosQuantities from './components/InfosQuantities.vue'
  import axios from 'axios'
  let isChanged=ref({
    promo:false,
    repart:false,
    fiche:false,
    dimensions:false,
    prixBase:false
  })
  let imageDialog=ref()
  let allColors=ref(false)
  const cab=ref(false)
  const dialog=ref(false)
  const repart=ref(false)
  const dialogFinale=ref(false)
  const PrixAchat=ref('')
  let vp=ref(false)
  let d1=ref(false)
  let d2=ref(false)
  let d3=ref(false)
  let ot=ref(false)
  let dialogDimensions=ref(false)
  let dialogSolde=ref(false)
  const props= defineProps({
    references:Object
  })
  const getCurrentPhotoName = () => {
    if (!props.references) return ''
    const firstKey = Object.keys(props.references)[0]
    return props.references[firstKey]?.photo_name || ''
  }

  const photo_name = ref(getCurrentPhotoName())

  // Watcher pour synchroniser
  watch(() => props.references, () => {
    photo_name.value = getCurrentPhotoName()
  }, { deep: true })
  const ordered=(referenced) =>{
    return Object.keys(referenced).sort().reduce(
        (obj, key) => { 

          obj[key] = referenced[key]; 
          return obj;
        }, 
        {}
      );
  }
  let articleInSolde=()=>{
    let cond={cond:false,type:''}
    for (let i in props.references){
      if(props.references[i].type_promo.match(/sol/gmi)){        
        cond={cond:true,type:'solde'}
        return cond
      }
      if(props.references[i].type_promo!=''){
        cond={cond:true,type:props.references[i].type_promo}
        return cond
      }
    } 
    return cond
  }
  const sumAD=(depo)=>{
    let sum=0
    for(let dep in depo){
      for (let cab in props.references) {
          sum=sum+(props.references[cab].stock[depo[dep]]?Number(props.references[cab].stock[depo[dep]]):0)
      }
    }
    return sum
  }
  let visible=defineModel(false)

  let visiblefunction=computed(()=>{
      let cond=false
      for(let key in props.references)
      { if(props.references[key].type_promo!=''){
        return cond=true
        }
      }
      
      return cond
  })
  const etabDEPO=ref({filliale:'DEPOT', etabliss:['DEPO','DWEB']})
  const etabAD=ref({filliale:'AD', etabliss:['DEFEC','DEPAD','LITIG','NEGO','PHOTO','RECEP','TRANS','NGEXT']})
  const etabReflex=ref({filliale:'Reflex', etabliss:['WEDI','WEBE','WENL','WETR','WOOM','WCAM','WAMZ']})
  const etabEtrier= ref({filliale:'Etrier', etabliss:['CA24','VX05','PR25']})
  const etabEdiBE=ref({filliale:'Edisac Belgique', etabliss:['BR08','NP19','GE22','OO10']})
  const etabEdiFrNord=ref({filliale:'Edisac Nord', etabliss:['DK03','MN01','EN11','FT04','LI02','RO06',]})
  const etabEdiPDC=ref({filliale:'Edisac PDC', etabliss:['AR09','CO18','HB21']})
  const etabLc=ref({filliale:'Lonchamp', etabliss:['LO07']})
  const edisacFranceCol=ref(false)
  const edisacBelgiqueCol=ref(false)
  const etabLcCol=ref(false)
  const etabReflexCol=ref(false)
  const etabEtrierCol=ref(false)
  const etabADCol=ref(false)
  let loading=ref(false)

  const acheteur=ref(props.references[Object.keys(props.references)[0]].acheteur)
  const pole=ref(props.references[Object.keys(props.references)[0]].pole)
  const douanier=ref(props.references[Object.keys(props.references)[0]].code_catdouanie)
  const codeTheme=ref(props.references[Object.keys(props.references)[0]].code_theme)
  const pays=ref(props.references[Object.keys(props.references)[0]].code_paysorigine)
  const composition=ref(props.references[Object.keys(props.references)[0]].code_composition)
  const fournisseur=ref(props.references[Object.keys(props.references)[0]].code_fourn)
  const codemarque=ref(props.references[Object.keys(props.references)[0]].code_marque)
    

  const collectionRef=ref(props.references[Object.keys(props.references)[0]].collection)
  let col=ref({
    'edisacFranceCol':edisacFranceCol,
    'edisacBelgiqueCol':edisacBelgiqueCol,
    'etabLcCol':etabLcCol,
    'etabReflexCol':etabReflexCol,
    'etabEtrierCol':etabEtrierCol,
    'etabADCol':etabADCol
  }
      
      
    )
  const edisacBelgique=()=>{
    edisacBelgiqueCol.value=!edisacBelgiqueCol.value
    edisacFranceCol.value=false
    etabLcCol.value=false
    etabEtrierCol.value=false
    etabReflexCol.value=false
    etabADCol.value=false
  }
  const edisacFrance=()=>{
    edisacFranceCol.value=!edisacFranceCol.value
    etabLcCol.value=false
    etabEtrierCol.value=false
    etabReflexCol.value=false
    edisacBelgiqueCol.value=false
    etabADCol.value=false
  }
  const edisacLongchamp=()=>{
    etabLcCol.value=!etabLcCol.value
    etabEtrierCol.value=false
    etabReflexCol.value=false
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
    etabADCol.value=false
  }
  const edisacEtrier=()=>{
    etabEtrierCol.value=!etabEtrierCol.value
    etabReflexCol.value=false
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
    etabLcCol.value=false
    etabADCol.value=false
    
  }
  const edisacReflex=()=>{
    etabReflexCol.value=!etabReflexCol.value
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
    etabLcCol.value=false
    etabEtrierCol.value=false
    etabADCol.value=false
    
  }
  const edisacAD=()=>{
    etabADCol.value=!etabADCol.value
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
    etabLcCol.value=false
    etabEtrierCol.value=false
    etabReflexCol.value=false
    
  }
  let valid=ref(true)
  let rules2=(value,libelle,reg)=>{
    let regex = new RegExp(reg)
    if (value){
      if(value.toString().match(regex)){
        valid.value=true
        return [true]
      } else{
        valid.value=false
        return [`Le ${libelle} n'est pas en bon format`]
      }
    }
  }

  let collections=ref([`${collectionRef}`,'E23','E24','E25','E26','E27','H23','H24','H25','H26','H27','R23','R24','R25','R26','R27'].filter(el=>el!=collectionRef))

  
  watch(collectionRef,(newcol,oldcol)=>{
      store.commit('updateIsChangedCol',{key:'ficheArticle',value:true})
      let referenceCol=props.references[Object.keys(props.references)[0]]
      let articlesTab=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]
      for(let key in articlesTab){
        if(store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][key].collection==oldcol){
          store.commit('updateCollection',{'referenceCol':referenceCol,'key':key,'collection':{newcol,oldcol}})
        }
      } 
  })
  const snackbar = ref(false)
  const snackbarMessage = ref('')
  const snackbarColor = ref('success')
  const showSnackbar = (message, color = 'success') => {
    snackbarMessage.value = message
    snackbarColor.value = color
    snackbar.value = true
  }
  async function validerPromo(){
    loading.value=true
    await validerArticles ()
    showSnackbar(`La promotion de la reférence ${props.references[Object.keys(props.references)[0]].reference_y2} a été modifié`, 'success')
  }
  async function validerArticles () {
    let referenceCol=props.references[Object.keys(props.references)[0]]
    let data = {articles:{...store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]},isChanged:isChanged.value,user:store.state.user}
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/articles',
    // url: 'http://localhost:8282/apimyedisac/articles',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
      isChanged.value={
        promo:false,
        repart:false,
        fiche:false,
        dimensions:false,
        prixBase:false
      }
      
    })
    .catch((error) => {
    });
  }

  const updatePrix= async (prix,validation)=>{
    let referenceCol=props.references[Object.keys(props.references)[0]]
    if(validation){
      allColors.value={
        prix:prix,
        validation:validation,
        reference:referenceCol.reference_y2
      }
    }else{
      store.commit('updateIsChangedCol',{key:'prixBase',value:true})
      let oldPrix=prix
      let newPrix=prix
      let articlesTab=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]
      for(let key in articlesTab){
        store.commit('updatePrix',{'referenceCol':referenceCol,'key':key,'prix':{oldPrix,newPrix}})
      } 
      isChanged.value.prixBase=true 
      await validerArticles()
      loading.value=false
      allColors.value.validation=validation
      showSnackbar(`Le prix de la référence ${props.references[Object.keys(props.references)[0]].reference_y2} a été modifié`, 'success')
      // console.log(store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]);
    }
   
    
    
  }
  const updateReference=(champs,value)=>{
    store.commit('updateIsChangedCol',{key:'ficheArticle',value:true})
    let referenceCol=props.references[Object.keys(props.references)[0]]
    let articlesTab=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]
    for(let key in articlesTab){
      store.commit('updateReference',{'referenceCol':referenceCol,'key':key,'data':{champs,value}})
    }  
  }

  let repartDialog=ref(false)
  const deletePromo= async ()=>{
    let solde=(vp.value||d1.value||d2.value||d3.value||ot.value)?{vp:vp.value?'vp':false,d1:d1.value?'d1':false,d2:d2.value?'d2':false,d3:d3.value?'d3':false,ot:ot.value?'ot':false}:false
    let data = {articles:props.references,solde:solde,user:store.state.user}
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/deletepromo',
    headers: { 
      'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
      if(response){
        store.commit('deletePromo',{marque:props.references[Object.keys(props.references)[0]].code_marque,theme:props.references[Object.keys(props.references)[0]].code_theme,reference:props.references[Object.keys(props.references)[0]].reference_y2})
        vp.value=false;
        d1.value=false;
        d2.value=false;
        d3.value=false;
        ot.value=false;
      }    
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  async function getBarCodes(){
    let barCodes=''
    for (let barcode in props.references ){
      barCodes=barCodes+`&barcodes=${props.references[barcode].codebarre}`
    }
    return barCodes
  }
  
  async function refreshPrices(etablissement,date){
    periodProperties.value=''
    // isChanged.value.promo=false
    let referenceCol= props.references[Object.keys(props.references)[0]]
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement}/selling-prices/v1?taxExcluded=false&date=${date}${ await getBarCodes()}`, //
      
      
      headers: { 
        'Authorization': `Bearer ${store.state.token_y2}`, 
        'Content-Type': 'application/json'
      }
    };
    axios.request(config)
    .then((response) => {
      for( let price in response.data.prices){
        if(response.data.prices[price].unitPrice.base!=response.data.prices[price].unitPrice.current){
          store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=response.data.prices[price].unitPrice.current.toFixed(1)
          store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=response.data.prices[price].periodId
          store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          refreshPeriodePromoUnit(etablissement,response.data.prices[price].periodId)
          
          
        }else{
          store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=0
          store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=''
          store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
        }
      }
    })
    .catch((error) => {
      //console.log(error);
    })  
    // console.log(store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]);
    
  }
  let productData=ref(null)
  let storeOptions=ref(null)
  let qteDialog = ref(false)
  async function groupById(data) {
    const groupedMap = new Map();
    
    data.forEach(item => {
        // Extraire l'ID principal (avant le premier espace ou caractère spécial)
        const mainId = item.id.split(/\s+/)[0]; // Prend la première partie avant l'espace
        
        // Si l'ID n'existe pas encore, on le crée
        if (!groupedMap.has(mainId)) {
            groupedMap.set(mainId, {
                id: mainId,
                stores: []
            });
        }
        
        const groupedItem = groupedMap.get(mainId);
        
        // Parcourir les stores de l'item courant
        item.stores.forEach(store => {
            // Chercher si ce store existe déjà dans l'item groupé
            let existingStore = groupedItem.stores.find(s => s.id === store.id);
            
            if (!existingStore) {
                // Si le store n'existe pas, on le crée
                existingStore = {
                    id: store.id,
                    warehouses: []
                };
                groupedItem.stores.push(existingStore);
            }
            
            // Parcourir les warehouses du store
            store.warehouses.forEach(warehouse => {
                // Chercher si ce warehouse existe déjà
                let existingWarehouse = existingStore.warehouses.find(w => w.id === warehouse.id);
                
                if (!existingWarehouse) {
                    // Si le warehouse n'existe pas, on le crée
                    existingWarehouse = {
                        id: warehouse.id,
                        quantities: {}
                    };
                    existingStore.warehouses.push(existingWarehouse);
                }
                
                // Additionner les quantités
                Object.keys(warehouse.quantities).forEach(key => {
                    const value = warehouse.quantities[key];
                    if (value !== 0) { // Optionnel : ignorer les zéros
                        existingWarehouse.quantities[key] = (existingWarehouse.quantities[key] || 0) + value;
                    }
                });
            });
        });
    });
    
    // Convertir la Map en tableau
    // console.log(Array.from(groupedMap.values()));
    return Array.from(groupedMap.values())[0];
  }
  const getReliquat = async () => {
      try {
          const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?fields=Quantities${await getBarCodes()}`,
          headers: {
              'Authorization': `Bearer ${store.state.token_y2}`,
              'Content-Type': 'application/json'
          }
          }
          
          const response = await axios.request(config)
          if (response.data?.length > 0) {
          productData.value = await groupById(response.data)
          storeOptions.value = productData.value.stores.map(store => { return `${store.id}`})
          qteDialog.value=true
          }
      } catch (error) {
          console.error('Erreur:', error)
      } 
  }
  watch(
    () => [store.state.etablissement, store.state.date],
    (newValues, oldValues) => {
        // Vérifier que les tableaux existent
        if (!newValues || !oldValues) return;
        
        const [newEtablissement, newDate] = newValues || [];
        const [oldEtablissement, oldDate] = oldValues || [];
        
        if (newEtablissement && newDate) {
          if(store.state.mode!='import'){
            refreshPrices(newEtablissement, newDate);
          }
            
            // refreshPeriodePromo(newEtablissement)
        }
    },
    { immediate: true, deep: true }
  )
  let periodProperties=ref(null)
  async function refreshPeriodePromoUnit(etablissement,type_promo){
    // isChanged.value=true
    // console.log(isChanged.value);
    
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement?etablissement:'WEDI'}/price-list-periods/v1/${type_promo}`, //
      headers: { 
        'Authorization': `Bearer ${store.state.token_y2}`, 
        'Content-Type': 'application/json'
      }
    };
    axios.request(config)
    .then((response) => {
      if(response.data.id){
        periodProperties.value=`Uniquement ces couleurs sont en ${response.data.description} du ${response.data.dateRange.startDate.split('T')[0]} au ${response.data.dateRange.endDate.split('T')[0]}`
        return
      }
      
    })
    .catch((error) => {
    })
  }
  async function refreshPeriodePromo(etablissement,date){
    // await refreshPrices(etablissement,date)
    let referenceCol= props.references[Object.keys(props.references)[0]]
    for (let bar in  store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]){
      if(store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][bar].type_promo
          &&store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][bar].type_promo!=''
        ){
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement?etablissement:'WEDI'}/price-list-periods/v1/${store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][bar].type_promo}`, //
          headers: { 
            'Authorization': `Bearer ${store.state.token_y2}`, 
            'Content-Type': 'application/json'
          }
        };
        axios.request(config)
        .then((response) => {
          if(response.data.id){
            periodProperties.value=`Uniquement ces couleurs sont en ${response.data.description} du ${response.data.dateRange.startDate.split('T')[0]} au ${response.data.dateRange.endDate.split('T')[0]}`
            return
          }
          
        })
        .catch((error) => {
        })
      }
      
    }
    periodProperties.value=null
  }


  onMounted(() => {

    isChanged.value={
        promo:false,
        repart:false,
        fiche:false,
        dimensions:false
      }
      if(store.state.mode!='import'){
        refreshPrices(store.state.itemsEtablissemnt.etabDEPO.etabliss.includes(store.state.etablissement)?'WEDI':store.state.etablissement,store.state.date)

      }
  })
  onUpdated(() => {
    isChanged.value.promo?isChanged.value.promo=false:''
  })



  
  </script>
  <style>
td{

    text-align: center;
    font-size: 10px;
  }
th{

    text-align: center;
    font-size: 10px;
    background-color: antiquewhite;

  }
tbody{
    font-size: 10px;
    border-collapse: separate; 
  border-spacing: 5em;
  }
  
  .codebarre{  
    border-top:0.01rem solid;
    border-color:lightgrey ;

  }
  .filiale {
    color:blue;
    cursor: pointer;
  }
  .filiale:hover{
    background-color: lightgrey
  }
  .iconplus{
    cursor: pointer;
  }
  .iconplus:hover{
    background-color: antiquewhite;
  }
  .iconrefresh{
    cursor: pointer;
  }
  .iconrefresh:hover{
    background-color: rgb(164, 223, 228);
  }
  .tableArticle{
    
    border: 0.1em  solid;
    border-color:lightgrey ;
    /* margin-left: 10px; */
  }

  </style>